import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'badge', 'toggleIcon', 'toggleButton']
  static values = {
    jurisdictionId: Number,
    open: { type: Boolean, default: false }
  }

  connect() {
    this.setupMultiSelect()
    this.setupFormListeners()
    this.updateBadge()
    this.openValueChanged()
  }

  setupMultiSelect() {
    const selects = this.element.querySelectorAll('select[multiple]')
    selects.forEach((select) => {
      select.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'OPTION') {
          e.preventDefault()
          const option = e.target
          option.selected = !option.selected
          select.dispatchEvent(new Event('change'))
        }
      })
    })
  }

  setupFormListeners() {
    const form = this.element.querySelector('form')
    if (!form) return
    form.addEventListener('change', () => this.updateBadge())
    form.addEventListener('input', () => this.updateBadge())
  }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (!this.hasPanelTarget) return
    if (this.openValue) {
      this.panelTarget.style.gridTemplateRows = '1fr'
      this.panelTarget.classList.add('open')
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.remove('rotate-0')
        this.toggleIconTarget.classList.add('rotate-180')
      }
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.setAttribute('aria-expanded', 'true')
      }
    } else {
      this.panelTarget.style.gridTemplateRows = '0fr'
      this.panelTarget.classList.remove('open')
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.remove('rotate-180')
        this.toggleIconTarget.classList.add('rotate-0')
      }
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.setAttribute('aria-expanded', 'false')
      }
    }
  }

  get activeFilterCount() {
    const form = this.element.querySelector('form')
    if (!form) return 0
    let count = 0
    form.querySelectorAll('input[type="date"]').forEach((input) => {
      if (input.value && input.value.trim() !== '') count++
    })
    form.querySelectorAll('select[multiple]').forEach((select) => {
      const selected = Array.from(select.options).filter((o) => o.selected)
      if (selected.length > 0) count++
    })
    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.checked) count++
    })
    return count
  }

  updateBadge() {
    if (!this.hasBadgeTarget) return
    const count = this.activeFilterCount
    this.badgeTarget.textContent = count
    this.badgeTarget.classList.toggle('hidden', count === 0)
  }

  clearFilters(event) {
    event.preventDefault()
    const form = this.element.querySelector('form')
    if (form) {
      form.querySelectorAll('input[type="date"]').forEach((input) => {
        input.value = ''
      })
      form.querySelectorAll('select').forEach((select) => {
        Array.from(select.options).forEach((option) => {
          option.selected = false
        })
      })
      form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false
      })
      this.updateBadge()
      form.submit()
    }
  }
}
